"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { ApiFetcher } from "./apiFetcher";
export type { ApiFetcher };
const ApiContext = createContext<ApiFetcher | null>(null);
interface ApiProviderProps {
  fetcher: ApiFetcher;
  children: ReactNode;
}

/**
 * Provides a configured API fetcher to all shared hooks.
 *
 * Each app wraps its component tree with this provider, passing a fetcher
 * that handles auth (cookies for web, Bearer token for desktop) and base URL.
 */
export function ApiProvider(t0) {
  const $ = _c(3);
  const {
    fetcher,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== fetcher) {
    t1 = <ApiContext.Provider value={fetcher}>{children}</ApiContext.Provider>;
    $[0] = children;
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useApiFetcher() {
  const fetcher = useContext(ApiContext);
  if (!fetcher) {
    throw new Error("useApiFetcher must be used within an ApiProvider");
  }
  return fetcher;
}